/*eslint-disable*/
import { TextField, withStyles, Typography, Divider } from "@material-ui/core";
import React from "react";

const styles = theme => ({
  textField: {
    width: "100%",
    marginTop: 0,
    marginBottom: 0
  }
});

function isEmptyOrSpaces(str) {
  return str === undefined || str === null || str.match(/^ *$/) !== null;
}

class AutofillV2 extends React.Component {
  state = {
    listOpen: false
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleChange = event => {
    event.preventDefault();
    this.setState({ listOpen: true });

    if (this.props.input.onChange && !this.props.readOnly) {
      this.props.input.onChange(event);
      this.props.input.onBlur(event);
      this.props.textChanged(event);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.meta.touched ||
      nextProps.input.value !== this.props.input.value ||
      nextProps.p_value !== this.props.p_value
    ) {
      this.forceUpdate();
    }
  }

  shouldComponentUpdate() {
    return true;
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  setListOpen = () => {
    this.setState({ listOpen: true });
  };

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ listOpen: false });
    }
  }

  selectItem = value => {
    this.setState({ listOpen: false });
    this.props.input.onChange(value);
    this.props.onItemSelect();
  };

  render() {
    this.props.meta.valid = false;

    let trySubmit = this.props.checkValidation ? true : false;

    const {
      meta: { touched, error, warning }
    } = this.props;

    let selectableItems = [];

    let lValue = this.props.fixedValue
      ? this.props.fixedValue
      : this.props.input.value
        ? this.props.input.value
        : "";

    let searchForOccupations = false;

    if (!isEmptyOrSpaces(lValue) && lValue.length > 2) {
      if (this.props.autoFillList.length > 0) {
        searchForOccupations = true;
        selectableItems = this.props.autoFillList.filter(a =>
          a.name.toLowerCase().includes(lValue.toLowerCase())
        );
      }
    }
    
    let notFound =
    searchForOccupations && !this.state.listOpen && selectableItems.length < 1
      ? true
      : false;

    let lOutputComponent = (
      <div ref={this.setWrapperRef}>
        <TextField
          onMouseDown={() => this.setListOpen()}
          onChange={this.handleChange}
          id={this.props.input.name}
          value={lValue}
          label={this.props.label}
          className={this.props.classes.textField}
          margin="normal"
          error={
            notFound ? true :
            error && error.length > 0 && touched
              ? true
              : error && error.length > 0 && trySubmit
                ? true
                : false
          }
          helperText={notFound ? "Invalid Occupation" : (error && touched) || (error && trySubmit) ? error : null}
          placeholder={this.props.placeholder}
        />
        {searchForOccupations && this.state.listOpen ? (
          <div className="autofillBox">
            {selectableItems.length < 1 ? (
              <Typography
                style={{ padding: "10px", color: "red" }}
                variant="body1"
              >
                No occupations found
              </Typography>
            ) : null}
            {selectableItems.map(s => (
              <div
                className="autofillItem"
                onClick={() => this.selectItem(s.name)}
              >
                <Typography style={{ padding: "10px" }} variant="body1">
                  {s.name}
                </Typography>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    );

    return <div>{lOutputComponent}</div>;
  }
}

export default withStyles(styles)(AutofillV2);



// WEBPACK FOOTER //
// ./src/components/Wrappers/materialUIWrappers/components/AutofillV2.js